import { Card, CardActionArea, CardContent, CardHeader, CardMedia, Grid, Typography, Box, Button, Modal } from "@mui/material";
import { Container, Tile } from "@ux/balance-react";
import React, { Fragment, useEffect, useState } from "react";
import './VideoThumbnail.css';
import thumbnail from '../../Assets/Images/play-video.jpg'
import VideoPlayer from "../VideoPlayer/VideoPlayer";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    height: '80%',
};

const VideoThumbnail = ({video}) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    
    return (
        <>
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
                className={"center"}
            >
                <Grid item xs={12}>
                    <Card sx={{ border: "none", boxShadow: "none" }}>
                        <CardActionArea onClick={handleOpen}>
                            <CardContent>
                                <img src={thumbnail} alt="video thumbnail" style={{border: ".1rem solid #8fc340"}} />
                                <Typography fontSize={24} color={"green"}>
                                    {
                                        video.name !== undefined ?
                                        video.name + " // " + video.time :
                                        "Test Title"
                                    }
                                </Typography>
                                <Typography>
                                    {
                                        video.description !== undefined ?
                                        video.description :
                                        "test description"
                                    }
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <VideoPlayer videoPath={video.path} closeVideo={handleClose} />
                </Box>
            </Modal>
        </>
    );
};

export default VideoThumbnail;